import { ReactNode, forwardRef, Ref, type JSX } from 'react';
import { Menu } from '@headlessui/react';
export const CustomDropdown = forwardRef(
  (
    {
      menuButtonEl,
      menuItemEl,
      show,
      toggle,
      menuButtonLabelButton,
      disabled,
    }: {
      menuButtonEl?: ReactNode;
      menuItemEl?: JSX.Element | JSX.Element[];
      show?: boolean;
      toggle?: () => void;
      menuButtonLabelButton?: ReactNode;
      disabled?: boolean;
    },
    ref?: Ref<HTMLElement>
  ) => (
    <Menu as="div" className="relative" ref={ref}>
      {() => (
        <>
          {menuButtonEl ? (
            <Menu.Button
              disabled={disabled}
              className="relative text-black bg-gray-50 text-base cursor-pointer rounded-md hover:bg-gray-100 hover:text-primary-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-primary-100 focus:ring-white lg:bg-transparent lg:truncate lg:text-base lg:w-full"
              onClick={(e: { preventDefault: () => void }) => {
                e.preventDefault();
                if (toggle) toggle();
              }}
            >
              {menuButtonEl}
            </Menu.Button>
          ) : menuButtonLabelButton ? (
            menuButtonLabelButton
          ) : null}
          {show && (
            <Menu.Items
              static
              className="mt-4 right-0 absolute w-full min-w-[18rem] max-w-[20rem] p-6 bg-white divide-y divide-gray-100 rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none relative z-10 transition duration-100 ease-out"
            >
              {menuItemEl ? <div className="p-1">{menuItemEl}</div> : <em>no items</em>}
            </Menu.Items>
          )}
        </>
      )}
    </Menu>
  )
);
export type AvatarDropdownType = {
  label: string;
  icon?: JSX.Element;
}[];
